'use client'

import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter, useSearchParams } from 'next/navigation'
import { handleAccount } from '@/(front-desk)/store'
import { useForm } from 'react-hook-form'
import { reportError } from '@/(front-desk)/utils/functions'
import Captcha from '@/(front-desk)/components/Captcha'
import Message from '@/(front-desk)/components/Message'
import logo from '@/(front-desk)/assets/images/2024/logo.png'
import PasswordDisplay from '@/(front-desk)/components/PasswordDisplay'
import InputGroup from '@/(front-desk)/components/form/InputGroup'
import axios from 'axios'
import classNames from 'classnames'
import lscache from 'lscache'
import Link from 'next/link'

export default function userLogin() {

    const dispatch = useDispatch()
    const global = useSelector((state) => state.global)
    const router = useRouter()
    const searchParams = useSearchParams()
    const passwordReset = searchParams.get('password-reset')
    const [ passwordDisplay, setPasswordDisplay ] = useState(false)
    const [ errorMessage, setErrorMessage ] = useState('')
    const [ captcha, setCaptcha ] = useState(null)
    const [ btnLoading, setBtnLoading ] = useState(null)
    const {
        register,
        formState: { errors, isValid },
        handleSubmit,
    } = useForm({
        defaultValues: {
            "email": '',
            "password": ''
        }
    })

    function login(data) {
        setBtnLoading(true)
        setErrorMessage('')
        axios.post('/api/v1/accounts/login', data)
        .then((res) => {
            // console.log('res', res.data)
            dispatch(handleAccount.actions.setData(res.data.body.user))
            lscache.set('access', res.data.body.access)
            lscache.set('refresh', res.data.body.refresh)
            router.push(global.userDefaultUrl)
            setBtnLoading(null)
        })
        .catch((err) => {
            // console.log(err.config?.url, err)

            if (err.response.status == 400) {
                setErrorMessage('帳號或密碼錯誤')
            }
            else {
                setErrorMessage('系統出了點問題，請再試一次！')
                reportError(err)
            }
            setBtnLoading(null)
        })
    }

    return (
        <>
        <title>登入 - 放視大賞</title>
        <main className="user-login">
            <div className="background-area"></div>
            <div className="form-area">
                <Link href="/">
                    <img className="logo" src={logo.src} alt="臺灣產學策進會放視大賞 Logo" />
                </Link>
                <h1 className="title">登入放視</h1>
                <div className="hint mb-6">
                    還沒有帳號？
                    <Link href="/user/sign-up" className="ms-1">立即註冊</Link>
                </div>
                <div className="flex flex-col gap-2 mb-4">
                    <Message type="error" display={errorMessage}>
                        {errorMessage}
                    </Message>
                    <Message type="success" display={passwordReset === 'true'}>
                        {passwordReset === 'true' && '密碼變更成功，請使用新密碼登入！'}
                    </Message>
                </div>
                <form id="main" className="login-form" onSubmit={handleSubmit(login)}>
                    <InputGroup className="mb-4" error={errors.email}>
                        <label htmlFor="email">帳號</label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="請輸入帳號 / Email"
                            {...register('email', {required: true})}
                        />
                    </InputGroup>
                    <InputGroup className="mb-6" error={errors.password}>
                        <label htmlFor="password">密碼</label>
                        <input
                            type={passwordDisplay ? 'text' : 'password'}
                            name="password"
                            id="password"
                            placeholder="請輸入密碼"
                            {...register('password', {required: true})}
                        />
                        <PasswordDisplay display={passwordDisplay} setDisplay={setPasswordDisplay} />
                    </InputGroup>
                    <Captcha setCaptcha={setCaptcha} />
                    <button
                        type="submit"
                        className={classNames('btn', 'btn-black', 'btn-round', 'w-full', 'mb-6', {
                            'loading': btnLoading
                        })}
                        disabled={!captcha || btnLoading || !isValid}
                    >登入</button>
                    <Link
                        className="btn btn-text block w-full text-center"
                        href="/user/password-forget"
                    >忘記密碼</Link>
                </form>
            </div>
        </main>
        </>
    )
}
